import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { configuracionAPI } from '../services/api';

const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);

  const refreshConfig = useCallback(async () => {
    try {
      const res = await configuracionAPI.getConfiguracion();
      setConfig(res.data.data || null);
    } catch {}
  }, []);

  useEffect(() => { refreshConfig(); }, [refreshConfig]);

  return (
    <ConfigContext.Provider value={{ config, refreshConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);
